"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var MultiCurrencyPrice_1 = require("./multiCurrency/MultiCurrencyPrice");
var useSummaryContext_1 = require("../../../react/useSummaryContext");
var PriceWithLabel_1 = require("../price/priceWithLabel/PriceWithLabel");
var CashPricesLabel_1 = require("./label/CashPricesLabel");
var PriceDisplayType_1 = require("../../../../../../common/enum/PriceDisplayType");
var CashPrices = function (_a) {
    var primaryPrice = _a.primaryPrice, isMultiCurrency = _a.isMultiCurrency, secondaryPrice = _a.secondaryPrice, dataTest = _a.dataTest;
    var _b, _c;
    var primaryOptions = useSummaryContext_1.default().priceDisplay.primaryOptions;
    if (isMultiCurrency) {
        return <MultiCurrencyPrice_1.default primaryPrice={primaryPrice} secondaryPrice={secondaryPrice} dataTest={dataTest}/>;
    }
    return (<PriceWithLabel_1.default price={(_b = primaryPrice) === null || _b === void 0 ? void 0 : _b.basePrice} priceDisplayType={PriceDisplayType_1.PriceDisplayType.PRIMARY} currency={(_c = primaryPrice) === null || _c === void 0 ? void 0 : _c.currency} decimals={primaryOptions.decimalScale} dataTest={dataTest} label={<CashPricesLabel_1.default />}/>);
};
exports.default = CashPrices;
